<template>
  <div class="bookmark-folder--actions d-flex">
    <link-button class="ml-2" v-if="canInvite" text="Invite colleagues to this folder" v-tooltip="'Invite anyone to this folder, they <br/> can access its full content after signing up for free'" icon="fa-user-plus" @click="openInviteModal()" />

    <link-button
      v-if="memberCount > 1"
      class="ml-2"
      :text="`${memberCount}`"
      icon="fa-users"
      @click="openContributorsModal()" />

    <dropdown
      placement="bottom-end"
      attachedToBody
    >
      <template #button>
        <link-button class="ml-2" icon="fa-pencil" />
      </template>

      <link-button v-if="canEdit" text="Edit name and privacy" icon="fa-pencil" @click="handleUpdate(bookmarkFolder)" />
      <link-button v-if="canInvite" text="Invite colleagues to this folder" icon="fa-user-plus" @click="openInviteModal()" />
      <link-button text="Show invited colleagues" icon="fa-list" @click="openContributorsModal()" />
      <hr class="my-1 bd-color-light"/>
      <link-button v-if="canEdit" text="Delete" icon="fa-trash t-red" @click="showDeleteConfirmation" />
      <link-button v-else text="Leave" icon="fa-eye-slash" @click="showLeaveConfirmation" />
    </dropdown>

  </div>
</template>

<script>
import MPService from '@/services/mixpanel'

import LinkButton from '@/components/shared/form/LinkButton'
import Dropdown from '@/components/shared/form/Dropdown'

import { mapActions } from 'vuex'

export default {
  name: 'bookmarkFolderActions',
  components: {
    LinkButton,
    Dropdown
  },
  props: {
    bookmarkFolder: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    parentView: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isRequest: false
    }
  },
  computed: {
    canEdit () {
      return this.$can.edit('bookmark', this.bookmarkFolder.rw_access)
    },
    canInvite () {
      return this.$can.invite('bookmark', this.bookmarkFolder.rw_access)
    },
    memberCount () {
      if (this.canInvite) {
        return this.bookmarkFolder.invite_count + this.bookmarkFolder.contributors.length
      }
      return this.bookmarkFolder.contributors.length
    }
  },
  methods: {
    ...mapActions('bookmarks', [
      'deleteBookmarkFolder',
      'leaveBookmarkFolder'
    ]),
    showLeaveConfirmation () {
      this.$dialog.confirm('Are you sure you want to leave this folder?', {
        okText: 'Leave',
        cancelText: 'Cancel',
        ok: dialog => this.handleLeave(dialog)
      }).then(dialog => {
        this.handleLeave(dialog)
      })
    },
    showDeleteConfirmation () {
      this.$dialog.confirm('Are you sure you want to delete this folder?', {
        okText: 'Delete',
        cancelText: 'Cancel',
        ok: dialog => this.handleRemove(dialog)
      }).then(dialog => {
        this.handleRemove(dialog)
      })
    },
    handleUpdate (bookmarkFolder) {
      this.$events.$emit('modal:bookmark_folder:open:create', { bookmarkFolder })
    },
    handleLeave (dialog) {
      if (this.isRequest) return

      this.isRequest = true
      this.leaveBookmarkFolder({ user: this.$currentUser, bookmarkFolder: this.bookmarkFolder })
        .then(this.leftBookmarkFolder)
        .catch(err => {
          this.$flash({ message: this.renderError(err) }, 'warning')
        }).finally(() => {
          dialog.close()
          this.isRequest = false
        })
    },
    handleRemove (dialog) {
      if (this.isRequest) return

      this.isRequest = true
      this.deleteBookmarkFolder(this.bookmarkFolder.slug_values[0])
        .then(this.leftBookmarkFolder)
        .catch(err => {
          this.$flash({ message: this.renderError(err) }, 'warning')
        }).finally(() => {
          dialog.close()
          this.isRequest = false
        })
    },
    leftBookmarkFolder () {
      let user = Object.assign({}, this.$currentUser)
      user.user_folder_ids.splice(user.user_folder_ids.findIndex((i) => i === this.bookmarkFolder.id), 1)
      this.$auth.setCurrentUser(user)

      this.$events.$emit('bookmark_folder:removed', this.bookmarkFolder)
      this.$events.$emit('modal:close')

      if (this.$route.name !== 'researcher.bookmark_folders.overview') {
        this.$router.push({ name: 'researcher.bookmark_folders.overview' })
      }
    },
    openInviteModal () {
      MPService.trackEvent('invite_colleagues_to_bookmark_folder', { type: this.parentView })

      this.$events.$emit('modal:invite:bookmark:open:create', this.bookmarkFolder)
    },
    openContributorsModal () {
      this.$events.$emit('modal:invite:bookmark:open:contributors', this.bookmarkFolder)
    }
  }
}
</script>
